import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import Constants from '../../../../../constants/en.json'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { getDateTimeFormattedValue } from '../../../../../utils/string-utils'
import NoResultsFoundTableOverlay from '../../../../../components/NoResultsFoundTableOverlay/no-results-found-table-overlay'

function DmsOrderHoldDetailsTable() {
  const theme = useTheme()
  const dmsOrderHoldDetails = useSelector((state) => state.orderList.dmsOrderHoldDetails)

  const rows = dmsOrderHoldDetails?.map((row) => ({
    id: row.sequence,
    description: row.description,
    onHold: row.onHold,
    enterTime: row.enterTime,
    enteredBy: row.enteredBy,
    releaseTime: row.releaseTime,
    releasedBy: row.releasedBy,
    releaseComment: row.releaseComment,
  }))

  const columns = [
    {
      field: 'description',
      headerName: Constants.orders.order_details.DESCRIPTION,
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'onHold',
      headerName: Constants.orders.order_details.ON_HOLD,
      flex: 0.5,
      minWidth: 80,
      valueFormatter: (value) => (value ? 'Yes' : 'No'),
    },
    {
      field: 'enterTime',
      headerName: Constants.orders.order_details.ENTER_TIME,
      flex: 1,
      minWidth: 150,
      headerAlign: 'right',
      align: 'right',
      renderCell: (cellValues) => {
        return getDateTimeFormattedValue(cellValues.value) || 'Pending'
      },
    },
    {
      field: 'enteredBy',
      headerName: Constants.orders.order_details.ENTERED_BY,
      flex: 0.5,
      minWidth: 100,
      valueFormatter: (value) => value ?? 'N/A',
    },
    {
      field: 'releaseTime',
      headerName: Constants.orders.order_details.RELEASE_TIME,
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      minWidth: 150,
      renderCell: (cellValues) => {
        return getDateTimeFormattedValue(cellValues.value) || 'Pending'
      },
    },
    {
      field: 'releasedBy',
      headerName: Constants.orders.order_details.RELEASED_BY,
      flex: 0.5,
      minWidth: 150,
      valueFormatter: (value) => value ?? 'N/A',
    },
    {
      field: 'releaseComment',
      headerName: Constants.orders.order_details.RELEASE_COMMENT,
      flex: 0.8,
      minWidth: 180,
      valueFormatter: (value) => value ?? 'N/A',
    },
  ]

  const gridStyle = {
    backgroundColor: theme.palette.common.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
  }

  return (
    <DataGrid
      sx={gridStyle}
      rows={rows}
      columns={columns}
      spacing={1}
      pageSizeOptions={[25, 50]}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
      slotProps={{
        pagination: {
          component: 'div',
          showLastButton: true,
          showFirstButton: true,
        },
      }}
      slots={{
        noResultsOverlay: NoResultsFoundTableOverlay,
      }}
      disableColumnFilter
      disableRowSelectionOnClick
    />
  )
}

export default DmsOrderHoldDetailsTable
